var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H16C7.16344 0 0 7.16344 0 16V48C0 56.8366 7.16344 64 16 64H48C56.8366 64 64 56.8366 64 48V16C64 7.16344 56.8366 0 48 0Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14V20.8621C21.6618 20.8773 29.005 23.9311 34.4195 29.3538C39.834 34.7766 42.878 42.1257 42.8841 49.79H49.79C49.7794 40.2997 46.0047 31.2015 39.2946 24.4924C32.5844 17.7834 23.4872 14.0119 14 14.0058V14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 26.244V33.0755C18.4248 33.0831 22.6656 34.8478 25.7906 37.9819C28.9157 41.116 30.6693 45.3631 30.6663 49.79H37.5461C37.54 43.5521 35.0625 37.5709 30.6564 33.1573C26.2503 28.7437 20.2751 26.2576 14.0401 26.244H14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6921 40.3716C17.7615 40.375 16.8527 40.6541 16.0805 41.1736C15.3083 41.6931 14.7074 42.4297 14.3536 43.2905C13.9998 44.1513 13.909 45.0976 14.0926 46.01C14.2762 46.9224 14.7261 47.7599 15.3853 48.4168C16.0446 49.0737 16.8837 49.5205 17.7968 49.7008C18.7098 49.8811 19.6558 49.7869 20.5153 49.4299C21.3748 49.073 22.1093 48.4694 22.626 47.6954C23.1427 46.9213 23.4184 46.0115 23.4184 45.0808C23.4139 43.8303 22.914 42.6325 22.0281 41.7499C21.1422 40.8672 19.9427 40.3716 18.6921 40.3716Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.6ee587d61b9e91e35a675e0ad9eb95cb.svg";
export { ForwardRef as ReactComponent };